import type {CardSystem} from '@yandex-delivery/api/model/payment'
import {IconSlugMobile} from '@yandex-delivery/bound-card/src/constants/icon-slug@mobile'

import {tagToUrl} from '../../../../lib/tagToUrl'

const mapCardSystemToIconSrc: Record<CardSystem, IconSlugMobile> = {
  maestro: IconSlugMobile.MAESTRO,
  mastercard: IconSlugMobile.MASTERCARD,
  mir: IconSlugMobile.MIR,
  unknown: IconSlugMobile.UNKNOWN,
  visa: IconSlugMobile.VISA,
}

export const getIconSrc = (system?: CardSystem): string => tagToUrl(mapCardSystemToIconSrc[system ?? 'unknown'])
